// src/components/app/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiServer, FiUsers, FiBriefcase, FiBox, FiPackage, FiBarChart2, FiFileText, FiCode } from 'react-icons/fi';
import './Sidebar.scss';
import { getVersion } from '../../versionConfig';

// Import the PNG image
import logoImage from '../../images/funique_Earthverse_logo_20240620.png';

const Sidebar = () => {
  const menuItems = [
    { path: '/servers', icon: <FiServer />, text: 'Server' },
    { path: '/dealers', icon: <FiBriefcase />, text: 'Dealers' },
    { path: '/users', icon: <FiUsers />, text: 'Users' },
    { path: '/permissions', icon: <FiFileText />, text: 'User Permissions' },
    { path: '/bundles', icon: <FiPackage />, text: 'Bundles' },
    { path: '/assets', icon: <FiBox />, text: 'Assets' },
    // { path: '/devices', icon: <FiMonitor />, text: 'User Device' },
    { path: '/data', icon: <FiBarChart2 />, text: '🚧數據統計' },
    { path: '/statistics', icon: <FiBarChart2 />, text: 'CDN Statistics' },
    { path: '/api-test', icon: <FiCode />, text: 'API Test' },
  ];

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <img src={logoImage} alt="EarthVerse CRM Logo" className="logo-image" />
      </div>
      <ul className="sidebar-menu">
        {menuItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              {item.icon}
              <span>{item.text}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="sidebar-footer">
        {/* show user_name */}
        {<p>使用者：{localStorage.getItem('user_name')}</p>}
        <p>版本：{getVersion()}</p>
      </div>
    </nav>
  );
};

export default Sidebar;